// extracted by mini-css-extract-plugin
module.exports = {"container":"EditorGlobalWarnings_container__YV7XZ"};